// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3V4vg","header":"PatientBlock_header__3OBNk","label":"PatientBlock_label__2Q7F8","option":"PatientBlock_option__1DJxY"};